(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bomm-pdp-pricing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bomm-pdp-pricing')) {
  customElements.define('bomm-pdp-pricing', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.variants = JSON.parse(this.querySelector('script').textContent);
      this.scope = this.closest('product-info');
      if (!this.scope) return;
      this.refresh = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      for (const name of ['change','input','variant:change','product:variant-change','variant:changed']) document.addEventListener(name, this.refresh, {signal:this.controller.signal});
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.scope, {subtree:true,childList:true,attributes:true,attributeFilter:['value','data-current-variant']});
      this.refresh();
    }
    update() {
      const form = this.scope.querySelector('form[data-type="add-to-cart-form"]');
      const id = form?.elements.namedItem('id')?.value;
      const variant = this.variants.find(item => String(item.id) === String(id));
      if (!variant || this.lastId === String(id)) return;
      const root = this.scope.querySelector('[data-bomm-payment-module]');
      if (!root) return;
      this.lastId = String(id);
      const price = Number(variant.price), compare = Number(variant.compare_at_price || 0);
      const transfer = Math.round(price * .95);
      const hasDiscount = compare > price;
      const saving = (hasDiscount ? compare : price) - transfer;
      const amounts = {transfer,saving,installment:Math.round(price/12),downpayment:Math.round(price*.35),balance:price-Math.round(price*.35)};
      const money = cents => '$' + Math.round(cents/100).toLocaleString('es-CL');
      for (const [role,cents] of Object.entries(amounts)) {
        const el = root.querySelector('[data-bomm-payment-role="'+role+'"]');
        if (el) { el.dataset.bommPaymentCents = String(cents); el.textContent = money(cents); }
      }
      const badge = root.querySelector('.bomm-payment-info__discount-badge');
      if (badge) badge.textContent = hasDiscount ? this.dataset.total.replace('{percent}', Math.round((compare-transfer)*100/compare)) : '-5%';
      const savingBox = root.querySelector('.bomm-payment-info__saving');
      if (savingBox) {
        const strong = savingBox.querySelector('strong');
        savingBox.replaceChildren(document.createTextNode((hasDiscount ? this.dataset.combined : this.dataset.saving)+' '), strong);
      }
      const finance = root.querySelector('[data-bomm-finance]');
      if (finance) finance.hidden = price < 100000000;
      const financeLabel = root.querySelector('[data-bomm-finance-label]');
      const cardLabel = root.querySelector('[data-bomm-card-label]');
      if (financeLabel) financeLabel.hidden = price < 100000000;
      if (cardLabel) cardLabel.hidden = price >= 100000000;
      const priceRoot = this.scope.querySelector('[data-bomm-pdp-price]');
      if (priceRoot) {
        priceRoot.dataset.currentVariant = String(id);
        priceRoot.classList.toggle('is-discounted',hasDiscount);
        priceRoot.classList.toggle('is-regular',!hasDiscount);
        const current = priceRoot.querySelector('.bomm-pdp-price__current');
        if (current) { current.textContent=money(price); current.dataset.bommPriceCents=String(price); }
        let old = priceRoot.querySelector('.bomm-pdp-price__compare');
        let discount = priceRoot.querySelector('.bomm-pdp-price__badge');
        if (hasDiscount) {
          if (!old) { old=document.createElement('span'); old.className='bomm-pdp-price__compare'; priceRoot.querySelector('.bomm-pdp-price__row').append(old); }
          old.textContent=money(compare); old.dataset.bommPriceCents=String(compare);
          if (!discount) { discount=document.createElement('div'); discount.className='bomm-pdp-price__badge'; priceRoot.prepend(discount); }
          discount.textContent='-'+Math.round((compare-price)*100/compare)+'%';
        } else { old?.remove(); discount?.remove(); }
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); this.controller=null; this.lastId=null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bomm-product-advice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bomm-product-advice')) {
  customElements.define('bomm-product-advice', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.link = this.querySelector('a');
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      const refresh = () => {
        const form = document.getElementById(this.dataset.form);
        const id = form?.elements.namedItem('id')?.value;
        const variant = this.variants.find(item => String(item.id) === String(id));
        const url = new URL(this.link.href);
        for (const key of ['variante','variante_id','sku','cantidad']) url.searchParams.delete(key);
        if (variant) {
          url.searchParams.set('variante_id', String(variant.id));
          if (variant.title !== 'Default Title') url.searchParams.set('variante', variant.title);
          if (variant.sku) url.searchParams.set('sku', variant.sku);
        }
        for (const key of ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','campana']) {
          const value = new URLSearchParams(location.search).get(key);
          if (value) url.searchParams.set(key,value.replace(/[\r\n]/g,' ').slice(0,60));
        }
        const quantity = form?.elements.namedItem('quantity')?.value || '1';
        if (/^[1-9]\d{0,5}$/.test(quantity)) url.searchParams.set('cantidad', quantity);
        this.link.href = url.href;
      };
      for (const event of ['click','auxclick','focus','pointerdown']) this.link.addEventListener(event, refresh, {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bomm-product-catalog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bomm-product-catalog')) {
  customElements.define('bomm-product-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const opts = {signal:this.controller.signal};
      this.trigger = this.querySelector('.bomm-product-catalog__trigger');
      this.dialog = this.querySelector('dialog');
      if (!this.trigger || !this.dialog || !this.dialog.showModal) return;
      this.stage = this.querySelector('.bomm-product-catalog__stage');
      this.paper = this.querySelector('.bomm-product-catalog__paper');
      this.canvas = this.querySelector('canvas');
      this.controls = this.querySelector('.bomm-product-catalog__controls');
      this.status = this.querySelector('.bomm-product-catalog__status');
      this.pageNumber = 1;
      this.zoom = 1;
      this.generation = 0;
      this.renderSequence = 0;
      this.trigger.setAttribute('aria-haspopup','dialog');
      this.trigger.setAttribute('aria-controls',this.dialog.id);
      this.trigger.setAttribute('aria-expanded','false');
      this.trigger.addEventListener('click',event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        this.open();
      },opts);
      this.querySelector('.bomm-product-catalog__close').addEventListener('click',()=>this.dialog.close(),opts);
      this.dialog.addEventListener('close',()=>this.close(),opts);
      this.dialog.addEventListener('click',event=>{
        if (event.target !== this.dialog) return;
        const r=this.dialog.getBoundingClientRect();
        if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();
      },opts);
      this.controls.addEventListener('click',event=>{
        const button=event.target.closest('[data-action]');
        if (!button || button.disabled || !this.pdf) return;
        this.navigate(button.dataset.action);
      },opts);
      this.dialog.addEventListener('keydown',event=>{
        if (!this.pdf || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key==='ArrowRight' || event.key==='ArrowLeft') {
          event.preventDefault();this.navigate(event.key==='ArrowRight'?'next':'prev');
        }
      },opts);
      this.observer=new ResizeObserver(()=>{
        if(!this.dialog.open||!this.pdf)return;
        clearTimeout(this.resizeTimer);
        this.resizeTimer=setTimeout(()=>this.draw(),140);
      });
      this.observer.observe(this.stage);
    }
    async open() {
      if (this.dialog.open) return;
      const generation=++this.generation;
      this.previousOverflow=document.documentElement.style.overflow;
      this.previousGutter=document.documentElement.style.scrollbarGutter;
      document.documentElement.style.scrollbarGutter='auto';
      this.dialog.showModal();document.documentElement.style.overflow='hidden';
      this.trigger.setAttribute('aria-expanded','true');
      this.pageNumber=1;this.zoom=1;this.paper.hidden=true;this.controls.hidden=true;
      this.status.hidden=false;this.querySelector('[data-loading]').hidden=false;
      this.querySelector('[data-error]').hidden=true;this.querySelector('[data-fallback]').hidden=true;
      try {
        if(!window.bommPdfEnginePromise)window.bommPdfEnginePromise=import(this.dataset.engine).catch(error=>{window.bommPdfEnginePromise=null;throw error;});
        const engine=await window.bommPdfEnginePromise;
        if(generation!==this.generation||!this.dialog.open)return;
        engine.GlobalWorkerOptions.workerSrc=this.dataset.worker;
        this.loadingTask=engine.getDocument({url:new URL(this.dataset.pdf,location.href).href,isEvalSupported:false,useWasm:true,useSystemFonts:true,isOffscreenCanvasSupported:false,isImageDecoderSupported:false});
        const pdf=await this.loadingTask.promise;
        if(generation!==this.generation||!this.dialog.open){await pdf.destroy();return;}
        this.pdf=pdf;await this.draw();
      } catch(error) {if(generation===this.generation&&this.dialog.open)this.fail();}
    }
    navigate(action) {
      if(action==='next')this.pageNumber=Math.min(this.pdf.numPages,this.pageNumber+1);
      if(action==='prev')this.pageNumber=Math.max(1,this.pageNumber-1);
      if(action==='in')this.zoom=Math.min(3,this.zoom+.5);
      if(action==='out')this.zoom=Math.max(1,this.zoom-.5);
      this.stage.scrollTo(0,0);this.draw();
    }
    async draw() {
      if(!this.pdf||!this.dialog.open)return;
      const seq=++this.renderSequence;
      this.renderTask?.cancel();
      try {
        const page=await this.pdf.getPage(this.pageNumber);
        if(seq!==this.renderSequence||!this.dialog.open)return;
        const base=page.getViewport({scale:1});
        const css=getComputedStyle(this.stage);
        const width=this.stage.clientWidth-parseFloat(css.paddingLeft)-parseFloat(css.paddingRight);
        const height=this.stage.clientHeight-parseFloat(css.paddingTop)-parseFloat(css.paddingBottom);
        const scale=Math.min(width/base.width,height/base.height)*this.zoom;
        const viewport=page.getViewport({scale});
        const ratio=Math.min(devicePixelRatio||1,2,Math.sqrt(10000000/(viewport.width*viewport.height)));
        const buffer=document.createElement('canvas');
        buffer.width=Math.max(1,Math.floor(viewport.width*ratio));buffer.height=Math.max(1,Math.floor(viewport.height*ratio));
        this.renderTask=page.render({canvasContext:buffer.getContext('2d'),viewport,transform:[ratio,0,0,ratio,0,0]});
        await this.renderTask.promise;
        if(seq!==this.renderSequence||!this.dialog.open)return;
        this.canvas.width=buffer.width;this.canvas.height=buffer.height;
        this.canvas.style.width=viewport.width+'px';this.canvas.style.height=viewport.height+'px';
        this.canvas.getContext('2d').drawImage(buffer,0,0);
        buffer.width=0;buffer.height=0;
        this.paper.hidden=false;this.controls.hidden=false;this.status.hidden=true;
        this.querySelector('.bomm-product-catalog__page').textContent=this.pageNumber+' / '+this.pdf.numPages;
        this.querySelector('[data-action="prev"]').disabled=this.pageNumber===1;
        this.querySelector('[data-action="next"]').disabled=this.pageNumber===this.pdf.numPages;
        this.querySelector('[data-action="out"]').disabled=this.zoom===1;
        this.querySelector('[data-action="in"]').disabled=this.zoom===3;
        const text=await page.getTextContent();
        if(seq===this.renderSequence)this.querySelector('.bomm-product-catalog__transcript').textContent=text.items.map(item=>item.str||'').join(' ');
      } catch(error) {if(error.name!=='RenderingCancelledException'&&seq===this.renderSequence&&this.dialog.open)this.fail();}
    }
    fail() {
      this.status.hidden=false;this.querySelector('[data-loading]').hidden=true;
      this.querySelector('[data-error]').hidden=false;this.querySelector('[data-fallback]').hidden=false;
    }
    close() {
      ++this.generation;++this.renderSequence;
      clearTimeout(this.resizeTimer);this.renderTask?.cancel();
      this.loadingTask?.destroy().catch(()=>{});this.loadingTask=null;this.pdf=null;
      this.canvas.width=0;this.canvas.height=0;
      document.documentElement.style.overflow=this.previousOverflow??'';
      document.documentElement.style.scrollbarGutter=this.previousGutter??'';
      this.trigger.setAttribute('aria-expanded','false');this.trigger.focus({preventScroll:true});
    }
    disconnectedCallback() {
      if(this.dialog?.open){this.dialog.close();this.close();}
      this.observer?.disconnect();this.controller?.abort();this.controller=null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
